<template>
  <div class="give-integral">
    <el-form :model="giveIntegralForm"
             :rules="rules"
             size="small"
             ref="giveIntegralFormRef"
             label-width="120px">
      <el-form-item label="赠送积分"
                    prop="integral">
        <el-input-number v-model="giveIntegralForm.integral"
                         step-strictly
                         :step="1"
                         :min="1"
                         :max="2000"
                         placeholder="请输入1-2000"
                         :controls="false"></el-input-number>
        <span style="margin-left:10px">积分</span>
      </el-form-item>

      <el-form-item label="赠送类型"
                    prop="give_type_obj">
        <el-select :value="giveIntegralForm.give_type_obj"
                   value-key="type_name"
                   placeholder="请选择"
                   @change="changeSelect">
          <el-option v-for="(item,index) in options"
                     :key="index"
                     :label="item.type_name"
                     :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="通知方式"
                    prop="notice_type">
        <el-checkbox-group v-model="giveIntegralForm.notice_type">
          <el-checkbox :label="1">短信</el-checkbox>
          <el-checkbox :label="2">公众号推送</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="giveIntegralForm.notice_type.includes(1)"
                    label="短信通知内容"
                    class="show-object-phone"
                    prop="sms_content">
        <el-input type="textarea"
                  v-model="giveIntegralForm.sms_content"
                  style="width:800px;"
                  :rows="6"
                  maxlength="120"
                  placeholder="请输入">
        </el-input>
        <div class="btn-item">
          <el-button type="primary"
                     size="small"
                     @click="importText(1)">引入默认内容</el-button>
        </div>
        <div>注：若内容中需要使用用户积分余额，请使用“ $X ”代替</div>
      </el-form-item>

      <el-form-item v-if="giveIntegralForm.notice_type.includes(2)"
                    label="公众号通知内容"
                    class="show-object-descAndRemark"
                    prop="descAndRemark">
        <el-form-item label="描述"
                      prop="wx_desc"
                      label-width="50px">
          <el-input v-model="giveIntegralForm.wx_desc"
                    type="textarea"
                    :rows="3"
                    style="width:750px;"
                    maxlength="50"
                    placeholder="请输入">
          </el-input>
          <div class="btn-item">
            <el-button type="primary"
                       size="mini"
                       @click="importText(2)">引入默认内容</el-button>
          </div>
        </el-form-item>
        <el-form-item label="备注"
                      prop="wx_remark"
                      label-width="50px">
          <el-input v-model="giveIntegralForm.wx_remark"
                    type="textarea"
                    :rows="3"
                    style="width:750px;"
                    maxlength="50"
                    placeholder="请输入">
          </el-input>
          <div class="btn-item">
            <el-button type="primary"
                       size="mini"
                       @click="importText(3)">引入默认内容</el-button>
          </div>
        </el-form-item>
      </el-form-item>

      <el-form-item label="赠送用户"
                    :prop="giveIntegralForm.type == 1 ? 'type1' : 'type2'">
        <el-radio-group v-model="giveIntegralForm.type"
                        @change="typeChange">
          <el-radio :label="1">输入用户</el-radio>
          <el-radio :label="2">选择用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="giveIntegralForm.type == 1"
                    label=""
                    prop="show_object_phone"
                    class="show-object-phone">
        <el-input type="textarea"
                  v-model="giveIntegralForm.show_object_phone"
                  style="width:800px;"
                  :rows="6"
                  placeholder="请填写或复制指定用户的手机号，用英文逗号隔开"
                  onkeyup="this.value=this.value.replace(/[ ]/g,'')">
        </el-input>
      </el-form-item>

      <el-form-item v-if="giveIntegralForm.type == 2"
                    label=""
                    prop="show_object_user"
                    class="show-object-phone show-object-user">
        <div class="user-box">
          <div class="left-table">
            <div class="header">
              <span class="title">未选用户</span>
              <span class="limt">{{totalNum-confirmUser.length}}/{{totalNum}}</span>
            </div>
            <div class="search">
              <el-input placeholder="请输入"
                        v-model="selectUserKeywords"
                        :show-message="false"
                        size="small"
                        clearable
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="searchUserList(1)"></el-button>
              </el-input>
            </div>
            <el-table ref="multipleTable"
                      :data="transferData"
                      border
                      height="400"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange">
              <el-table-column type="selection"
                               width="55">
              </el-table-column>
              <el-table-column label="用户昵称"
                               prop="nick_name">
              </el-table-column>
              <el-table-column label="用户手机号"
                               prop="phone">
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination v-show="totalNum>0"
                        :total="totalNum"
                        :page.sync="pagination.page"
                        layout="total, prev, pager, next"
                        :limit.sync="pagination.pageNumber"
                        @pagination="getAllUserList" />
          </div>

          <div class="btn-box">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-arrow-left"
                       @click="leftClick"></el-button>
            <el-button type="primary"
                       size="small"
                       @click="rightClick"><i class="el-icon-arrow-right el-icon--right"></i></el-button>
          </div>

          <div class="right-table">
            <div class="header">
              <span class="title">已选用户</span>
              <span class="limt">{{confirmUser.length}}/{{totalNum}}</span>
            </div>
            <div class="search">
              <el-input placeholder="请输入"
                        v-model="confirmUserKeywords"
                        size="small"
                        clearable
                        class="input-with-select">
                <el-button slot="append"
                           icon="el-icon-search"
                           @click="searchUserList(2)"></el-button>
              </el-input>
            </div>
            <el-table ref="rightMultipleTable"
                      :data="confirmUser"
                      height="400"
                      tooltip-effect="dark"
                      border
                      style="width: 100%"
                      @selection-change="handleSelectionRightChange">
              <el-table-column type="selection"
                               width="55">
              </el-table-column>
              <el-table-column label="用户昵称"
                               prop="nick_name">
              </el-table-column>
              <el-table-column label="用户手机号"
                               prop="phone">
              </el-table-column>
            </el-table>
            <!-- 分页占位 -->
            <pagination style="opacity: 0;"
                        :total="totalNum"
                        :page.sync="pagination.page"
                        layout="total, prev, pager, next"
                        :limit.sync="pagination.pageNumber"
                        @pagination="getAllUserList" />
          </div>

        </div>
      </el-form-item>

      <el-form-item style="text-align: left;">
        <el-button type="primary"
                   size="small"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1350') : false"
                   @click="saveForm('giveIntegralFormRef')">保存</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import integralmanage from '../../../api/integralmanage';
import common from '../../../api/common';
import { validUserPhone } from '@/service/utils/my-validate.js';
import _ from 'lodash';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    let validShowObjectPhone = (rule, value, callback) => {
      if (this.giveIntegralForm.show_object_phone.trim() === '') {
        callback(new Error('请输入手机号'));
        return;
      }
      this.giveIntegralForm.show_object_phone =
        this.giveIntegralForm.show_object_phone
          .trim()
          .replace(/[\,\，]/g, ',')
          .replace(/[\r\n]/g, '')
          .replace('\u202c', '')
          .replace('\u202d', '')
          .replace('\u202e', '');
      this.giveIntegralForm.show_object_phone =
        this.giveIntegralForm.show_object_phone.replace(/[\r\n]/g, '');
      if (!validUserPhone(this.giveIntegralForm.show_object_phone)) {
        callback(new Error('请填写或复制指定用户的手机号，用英文逗号隔开'));
      } else {
        callback();
      }
    };
    let validShowObjectUser = (rule, value, callback) => {
      if (this.giveIntegralForm.show_object_user.trim() === '') {
        callback(new Error('请选择用户'));
        return;
      } else {
        callback();
      }
    };
    return {
      giveIntegralForm: {
        integral: undefined,
        notice_type: [2],
        give_type_obj: '',
        type: 1,
        show_object_phone: '',
        show_object_user: '',
        sms_content: '',
        wx_desc: '',
        wx_remark: ''
      },
      rules: {
        integral: [{ required: true, message: '请输入', trigger: 'blur' }],
        sms_content: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        wx_desc: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        wx_remark: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],

        give_type_obj: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        type1: [
          {
            required: true,
            validator: validShowObjectPhone,
            trigger: 'blur'
          }
        ],
        type2: [
          {
            required: true,
            validator: validShowObjectUser,
            trigger: 'blur'
          }
        ]
      },
      options: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 15
      },
      transferData: [],
      selectUserVal: [],
      rightSelectUserVal: [],
      confirmUser: [],
      cloneDeepConfirmUser: [],
      selectUserKeywords: '',
      confirmUserKeywords: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getOptions();
    this.getAllUserList();
  },
  methods: {
    // 获取赠送积分类型
    getOptions() {
      integralmanage.getIntegralGiveType().then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.options = data.list;
        }
      });
    },
    changeSelect(e) {
      this.giveIntegralForm.give_type_obj = e;
    },
    // 赠送积分
    userIntegralGive() {
      const loading = this.$loading();
      let params = _.pick(this.giveIntegralForm, [
        'integral',
        'notice_type',
        'type',
        'sms_content',
        'wx_desc',
        'wx_remark'
      ]);
      params.notice_type = params.notice_type.join(',');
      params.give_type = this.giveIntegralForm.give_type_obj.type_name;
      params.give_type_int = this.giveIntegralForm.give_type_obj.type;
      switch (params.type) {
        case 1:
          params.list = this.giveIntegralForm.show_object_phone;
          break;
        case 2:
          params.list = this.giveIntegralForm.show_object_user;
          break;
      }
      integralmanage
        .userIntegralGive(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('赠送成功');
            this.giveIntegralForm = {
              integral: undefined,
              notice_type: [2],
              give_type_obj: '',
              type: 1,
              show_object_phone: '',
              show_object_user: '',
              sms_content: '',
              wx_desc: '',
              wx_remark: ''
            };
            this.confirmUser = [];
            this.$nextTick(() => {
              this.$refs['giveIntegralFormRef'].clearValidate();
            });
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let peopleNum = 0;
          switch (this.giveIntegralForm.type) {
            case 1:
              peopleNum =
                this.giveIntegralForm.show_object_phone.split(',').length;
              break;
            case 2:
              peopleNum =
                this.giveIntegralForm.show_object_user.split(',').length;
              break;
          }
          this.$confirm(
            `当前赠送用户有${peopleNum}人，确定要每位用户赠送${this.giveIntegralForm.integral}积分吗？`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }
          )
            .then(() => {
              this.userIntegralGive();
            })
            .catch(() => {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    typeChange() {
      this.$nextTick(() => {
        this.$refs['giveIntegralFormRef'].clearValidate();
        if (this.$refs.multipleTable) {
          this.confirmUser.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(
              this.transferData.find((item) => row.user_id == item.user_id),
              true
            );
          });
        }
      });
    },
    // 引入内容
    importText(type) {
      switch (type) {
        case 1:
          this.giveIntegralForm.sms_content = `尊敬的用户您好，歧黄医官赠送您积分，当前账户积分$X（可抵扣$X/10元），点击前往兑换超值物品：qhyiguan.com/4lSU`;
          break;
        case 2:
          this.giveIntegralForm.wx_desc = '您好,歧黄医官赠送您积分';
          break;
        case 3:
          this.giveIntegralForm.wx_remark =
            '获取的积分可在歧黄商城中购买商品抵扣哦~';
          break;
      }
    },
    /* **** 选择用户 **** */
    searchUserList(type) {
      switch (type) {
        case 1:
          this.pagination.page = 1;
          this.getAllUserList();
          break;

        case 2:
          if (this.confirmUserKeywords != '') {
            this.confirmUser = this.cloneDeepConfirmUser.filter((item) => {
              return (
                item.nick_name == this.confirmUserKeywords ||
                item.phone == this.confirmUserKeywords
              );
            });
          } else {
            this.confirmUser = this.cloneDeepConfirmUser;
          }

          break;
      }
    },
    getAllUserList() {
      let params = Object.assign(
        {},
        { keywords: this.selectUserKeywords },
        this.pagination
      );
      common.getAllUserList(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.transferData = data.list;
          this.totalNum = data.total;

          this.$nextTick(() => {
            this.confirmUser.forEach((row) => {
              this.$refs.multipleTable.toggleRowSelection(
                this.transferData.find((item) => row.user_id == item.user_id),
                true
              );
            });
          });
        }
      });
    },
    handleSelectionChange(e) {
      this.selectUserVal = _.unionBy(e, this.confirmUser, 'user_id');
    },
    handleSelectionRightChange(e) {
      this.rightSelectUserVal = e;
    },
    leftClick() {
      if (!this.rightSelectUserVal.length) {
        this.$message.warning('请选择');
        return;
      }
      let arr = _.xorWith(
        this.selectUserVal,
        this.rightSelectUserVal,
        _.isEqual
      ).filter((item) => item);

      if (!arr.length) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
          arr.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(
              this.transferData.find((item) => row.user_id == item.user_id),
              true
            );
          });
        });
      }
      this.confirmUser = arr;
      this.giveIntegralForm.show_object_user = arr
        .map((item) => item.user_id)
        .join(',');
      this.cloneDeepConfirmUser = _.cloneDeep(this.confirmUser);
      this.selectUserVal = arr;
    },
    rightClick() {
      if (!this.selectUserVal.length) {
        this.$message.warning('请选择');
        return;
      }
      this.confirmUser = JSON.parse(JSON.stringify(this.selectUserVal)).filter(
        (item) => item
      );
      this.cloneDeepConfirmUser = _.cloneDeep(this.confirmUser);
      this.giveIntegralForm.show_object_user = this.confirmUser
        .map((item) => item.user_id)
        .join(',');
      this.$nextTick(() => {
        this.confirmUser.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(
            this.transferData.find((item) => row.user_id == item.user_id),
            true
          );
        });
      });
    }
  }
};
</script>

<style lang="scss" >
.give-integral {
  text-align: left;
  .show-object-phone {
    position: relative;
    .el-form-item__content {
      height: 160px;
    }
    .btn-item {
      position: absolute;
      left: 690px;
      bottom: 40px;
    }
  }
  .show-object-descAndRemark {
    position: relative;
    .el-form-item__label::before {
      content: '*';
      color: #e53528;
      margin-right: 4px;
    }
    & > .el-form-item__content {
      height: 180px;
      .el-form-item__content {
        height: 80px;
      }
      .el-form-item__label::before {
        content: '';
      }
    }
    .btn-item {
      position: absolute;
      left: 640px;
      bottom: 14px;
    }
  }
  .show-object-user {
    // .el-textarea {
    //   textarea {
    //     cursor: pointer;
    //   }
    // }
    .el-form-item__content {
      height: auto;
    }
    .user-box {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      .header {
        height: 40px;
        line-height: 40px;
        border: 1px solid #ebeef5;
        border-bottom: none;
        padding-left: 10px;
        .title {
          font-size: 16px;
          font-weight: bold;
          margin-right: 10px;
        }
        .limt {
          font-size: 14px;
          font-weight: bold;
        }
      }
      .search {
        border: 1px solid #ebeef5;
        border-bottom: none;
        padding: 10px 40px;
      }
      .left-table {
        width: 400px;
      }
      .btn-box {
        margin: 0 20px;
      }
      .right-table {
        width: 400px;
      }
    }
  }
}
.giveIntegral-dialog {
  .diaCodebox {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header {
      height: 40px;
      line-height: 40px;
      border: 1px solid #ebeef5;
      border-bottom: none;
      padding-left: 10px;
      .title {
        font-size: 16px;
        font-weight: bold;
        margin-right: 10px;
      }
      .limt {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .search {
      border: 1px solid #ebeef5;
      border-bottom: none;
      padding: 10px 40px;
    }
    .left-table {
      width: 40%;
    }
    .right-table {
      width: 40%;
    }
  }
}
</style>